
import { Component, ElementRef, OnInit } from '@angular/core';
import { PageBase, T4SettingsPage, T4SettingsService, ControlType, T4Setting } from 't4core';
import { T4WebHookSettingsService } from 't4core';

@Component({
  styleUrls: ['./ManageIntegrations.css'],
  selector: 'ManageIntegrations',
  templateUrl: './ManageIntegrations.component.html',
})
export class ManageIntegrationsComponent extends PageBase implements OnInit {
  public pages: T4SettingsPage[] = [];
  public Controls = ControlType;

  constructor(el: ElementRef, private svcSettings: T4WebHookSettingsService) {
    super(el, "Settings");

  }

  async ngOnInit() {
    this.GetPages();
  }

  public async GetPages() {
    var token = this.UI.beginLoading("T4.Settings.Settings.msgLoading", "Loading settings", null);
    this.pages = await this.svcSettings.GetWebHookSettings();
    this.UI.loaderCompleted(token);
  }

  public async saveSettings(setting: T4SettingsPage) {
    var ret = await this.svcSettings.SaveWebHookSetting(setting);
    if (ret) {
      this.UI.snackBar("Saved");
    }    
  }
}
